import { EduJabatanApiPath, EduKelasApiPath, EduPembelajaranApiPath, EduPendidikanApiPath, EduPenilaianApiPath, EduProfesiApiPath, EduUniversitasApiPath, EduJurusanApiPath, EduTahunAjaranApiPath, EduPeriodeApiPath, EduBlokWaktuApiPath, EduLombaApiPath, MenuIds, } from "../../../constants";
import { getWithMenu, postWithMenu } from "../../helpers";
export const getSearchEduJabatan = async (searchParams) => {
    return await getWithMenu(EduJabatanApiPath, MenuIds.MASTER_DATA.EDU.JABATAN.id, searchParams);
};
export const getSearchEduKelas = async (searchParams) => {
    return await getWithMenu(EduKelasApiPath, MenuIds.MASTER_DATA.EDU.KELAS.id, searchParams);
};
export const getSearchEduPembelajaran = async (searchParams) => {
    return await getWithMenu(EduPembelajaranApiPath, MenuIds.MASTER_DATA.EDU.PEMBELAJARAN.id, searchParams);
};
export const getSearchEduPendidikan = async (searchParams) => {
    return await getWithMenu(EduPendidikanApiPath, MenuIds.MASTER_DATA.EDU.PENDIDIKAN.id, searchParams);
};
export const getSearchEduPenilaian = async (searchParams) => {
    return await getWithMenu(EduPenilaianApiPath, MenuIds.MASTER_DATA.EDU.PENILAIAN.id, searchParams);
};
export const getSearchEduProfesi = async (searchParams) => {
    return await getWithMenu(EduProfesiApiPath, MenuIds.MASTER_DATA.EDU.PROFESI.id, searchParams);
};
export const getEduKelasById = async (id) => {
    return await getWithMenu(`${EduKelasApiPath}/${id}`, MenuIds.MASTER_DATA.EDU.KELAS.id);
};
export const getSearchEduUniversitas = async (searchParams) => {
    return await getWithMenu(EduUniversitasApiPath, MenuIds.MASTER_DATA.EDU.PERGURUAN_TINGGI?.id || MenuIds.EDU.SCHOOL_MANAGEMENT_SYSTEM.PENGATURAN.TARGET_PTN.id, // Fallback to current module menu ID if master not available
    searchParams);
};
export const getSearchEduJurusan = async (searchParams) => {
    return await getWithMenu(EduJurusanApiPath, MenuIds.MASTER_DATA.EDU.JURUSAN?.id || MenuIds.EDU.SCHOOL_MANAGEMENT_SYSTEM.PENGATURAN.TARGET_PTN.id, searchParams);
};
export const getSearchEduTahunAjaran = async (searchParams) => {
    return await getWithMenu(EduTahunAjaranApiPath, MenuIds.MASTER_DATA.EDU.KALENDER_AKADEMIK.id, searchParams);
};
export const getSearchEduPeriode = async (searchParams) => {
    return await getWithMenu(EduPeriodeApiPath, MenuIds.MASTER_DATA.EDU.KALENDER_AKADEMIK.id, searchParams);
};
export const getSearchEduBlokWaktu = async (searchParams) => {
    return await getWithMenu(EduBlokWaktuApiPath, MenuIds.MASTER_DATA.EDU.JAM_BELAJAR.id, searchParams);
};
export const getSearchEduLomba = async (searchParams) => {
    return await postWithMenu(`${EduLombaApiPath}/search`, searchParams, MenuIds.MASTER_DATA.EDU.KATALOG_LOMBA.id);
};
